export class ViewModelMovimentacaoEmp {
    idContratoEmp: number;
    nrSeqPrest: number;
    idLancIntEmp: number;
    nmLancIntEmp: string;
    idOperacao: number;
    dtReferencia: string;
    idTipoRecebimento: number;
    vlMovimento: number;
    icRetroativo: string;
    vinculo: string;
}